/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEventAvailable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 2v1.999h6V2h2v1.999h5V22H2V4l5-.001V2zM7 5.999H4v14h16V6h-3v2h-2V6H9v2H7zm9.336 3.254 1.328 1.494-7.704 6.627-3.667-3.667 1.414-1.414 2.333 2.333z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEventAvailable as EventAvailable };
